// Auto-generated by tools/inline_commands.js on 2025-10-17T02:49:13.557Z
// This file now contains a single exported list with origin/usage inlined per entry.

export const yojijukugoList = [
  {
    "text": "ls",
    "color": "#FF5733",
    "kunyomi": "さぁ、目に映るすべてをここに示す──準備はいいか？",
    "mondai": "中身を一覧で見たい",
    "example": [
      "$ ls",
      "Documents  Downloads  Pictures",
      "Music      Videos     Desktop"
    ],
    "origin": "list（一覧）の略。ファイル/ディレクトリを一覧するコマンド。",
    "usage": "フォルダの中身をずらっと見る。こまかい情報や隠しファイルまで見るなら ls -lah。見落としが減って、作業ミスも防げる。",
    "missing_impact": "何がどこにあるかすぐ分からず、作業の出発点でつまずく。",
    "background": "初期のUNIXで、作業ディレクトリの内容を一目で確認するために作られた基本コマンド。開発や運用の“最初の一歩”として定着した。",
    "trivia": "ls の出力結果を見やすくしたい？だったら環境変数LS_COLORSを設定しよう。ファイルの種類や拡張子ごとに色分けできる。"
  },
  {
    "text": "cd",
    "color": "#33FF57",
    "kunyomi": "進め。次の場所へ、確かな一歩で。",
    "mondai": "そのフォルダに移動したい",
    "example": [
      "$ cd Documents",
      "/home/user/Documents"
    ],
    "origin": "change directory（ディレクトリを変える）。",
    "usage": "作業する場所（フォルダ）を移動する。ひとつ前に戻るなら cd -。迷わず目的の場所で作業できる。",
    "missing_impact": "必要な場所へ移動できず、目的のファイルにたどり着くのが大変。回り道や誤操作が増える。",
    "background": "UNIXの階層型ファイルシステムとセットで生まれた基本操作。場所を変えて作業する“当たり前”を担う。"
  },
  {
    "text": "pwd",
    "color": "#3357FF",
    "kunyomi": "我が居場所はここだ。道を見失うな。",
    "mondai": "今どこ？",
    "example": [
      "$ pwd",
      "/home/user/projects/garlic_hamster"
    ],
    "origin": "print working directory（現在の作業ディレクトリを表示）。",
    "usage": "いま自分がいる場所（フォルダの道すじ）のパスを表示する。",
    "missing_impact": "自分の居場所が分からず、別環境や重要ディレクトリで間違って操作してしまう危険が高まる。",
    "background": "“カレントディレクトリ”という考え方とともに普及。スクリプトでも現在地チェックに欠かせない存在。"
  },
  {
    "text": "mkdir",
    "color": "#FF33A1",
    "kunyomi": "新たな道筋を刻め。開け、未来よ。",
    "mondai": "新しいフォルダを作りたい",
    "example": [
      "$ mkdir projects",
      "$ ls",
      "projects"
    ],
    "origin": "make directory（ディレクトリ作成）。",
    "usage": "新しいフォルダを作る。作業の準備がすぐ整って効率が上がる。",
    "missing_impact": "プロジェクトや用途ごとに整理できず、ファイルが散らかって見つけにくくなる。",
    "background": "UNIXの“小さな部屋を作り分ける”思想を支える基本コマンドとして早期から存在。"
  },
  {
    "text": "rm",
    "color": "#FFC300",
    "kunyomi": "不要なものは断つ。潔く、消し去れ。",
    "mondai": "不要なファイルを消したい",
    "example": [
      "$ rm oldfile.txt",
      "$ rm -r olddir"
    ],
    "origin": "remove（削除）。",
    "usage": "いらないファイルやフォルダを消す。",
    "missing_impact": "不要物が増え続け、容量不足やゴミによる混乱が起きる。",
    "background": "ファイル管理の基礎。後から安全確認のためのフラグ（-i など）が整備され、事故を減らす工夫が広まった。"
  },
  {
    "text": "cp",
    "color": "#DAF7A6",
    "kunyomi": "同じ景色を複製し、任務を前へ。",
    "mondai": "ファイルをコピーしたい",
    "example": [
      "$ cp source.txt backup.txt",
      "$ ls",
      "source.txt  backup.txt"
    ],
    "origin": "copy（複製）。",
    "usage": "ファイルやフォルダをコピーする。",
    "missing_impact": "バックアップや試し作業の複製ができず、元データを壊すリスクが上がる。",
    "background": "磁気テープ時代から続く“複製”の基本操作。属性保持や再帰コピーなど、用途に合わせ進化してきた。"
  },
  {
    "text": "mv",
    "color": "#C70039",
    "kunyomi": "位置を変え、運命を書き換えろ。",
    "mondai": "ファイルを移動/リネームしたい",
    "example": [
      "$ mv oldname.txt newname.txt",
      "$ ls",
      "newname.txt"
    ],
    "origin": "move（移動/改名）。",
    "usage": "ファイルを移動したり、名前を変えたりする。整理整頓が進んで探しやすくなる。",
    "missing_impact": "整理や命名のやり直しができず、似たファイルが散らばって管理が難しくなる。",
    "background": "同一ディスク内では実体を動かさず“参照の付け替え”で高速化するなど、内部実装も工夫されている。"
  },
  {
    "text": "touch",
    "color": "#900C3F",
    "kunyomi": "ひとつ、空に印を刻む。始まりの合図だ。",
    "mondai": "空ファイルを作りたい",
    "example": [
      "$ touch newfile.txt",
      "$ ls -la newfile.txt",
      "-rw-r--r--  1 user  group  0 Sep 15 10:30 newfile.txt"
    ],
    "origin": "ファイルの最終更新時刻に触れる（touch）。空ファイルも作れる。",
    "usage": "空のファイルを作る。更新時刻だけを新しくすることもできる。準備や合図に使えて、後の作業がスムーズ。",
    "missing_impact": "“とりあえず置く”空ファイルやタイムスタンプ更新ができず、ビルドや監視のトリガー作成が不便。",
    "background": "makeのような“更新日時で判断する仕組み”と相性がよく、開発現場で重宝されてきた。"
    ,"trivia": "新規作成でよく使われる理由: ワンコマンドで空ファイルを素早く作れるだけでなく、既存ファイルの中身を上書きしない安全性があるため。 そもそもファイルのタイムスタンプを更新できると何がうれしいの？ — 中身を変えずに“更新された”とシステムに伝えられる点が便利。例: make の再ビルド判定、rsync 等の差分同期、キャッシュ再配布のトリガー、ジョブの順序制御。"
  },
  {
    "text": "cat",
    "color": "#FF5733",
    "kunyomi": "真実を見よ。そこに答えがある。",
    "mondai": "ファイルの中身を見たい",
    "example": [
      "$ cat hello.txt",
      "Hello, World!",
      "This is a sample file."
    ],
    "origin": "concatenate（連結）の短縮。中身を連結/表示する。",
    "usage": "小さなファイルの中身を表示する。つなげて次の処理に渡すこともできる。内容をすばやく確かめられて手戻りが減る。",
    "missing_impact": "内容の素早い確認やパイプでの連結が難しくなり、調査や小さな加工のスピードが落ちる。",
    "background": "フィルタをつなぐUNIX哲学の中心的なコマンド。単純だが多用途で、今も現役。"
  },
  {
    "text": "less",
    "color": "#33FF57",
    "kunyomi": "前へ進め。長きページを静かに追うがいい。",
    "mondai": "長いファイルをページ送りで見たい",
    "example": [
      "$ less document.txt",
      "First line of the file",
      "Second line of the file",
      "Press q to quit"
    ],
    "origin": "less is more の洒落。moreの改良版ページャ。",
    "usage": "長いファイルをページ送りで読む。検索や上下移動がしやすい。長文でも迷わず読み進められる。",
    "missing_impact": "長いログやドキュメントを快適に読めず、検索やスクロールが大変で原因調査が遅れる。",
    "background": "前身のmoreの弱点（戻れない等）を解消するために作られ、ログ閲覧の標準として広く普及した。"
  },
  {
    "text": "head",
    "color": "#3357FF",
    "kunyomi": "先頭を見定めろ。そこに指針がある。",
    "mondai": "先頭だけ見たい",
    "example": [
      "$ head -5 logfile.txt",
      "2025-09-15 10:30:01 INFO: System started",
      "2025-09-15 10:30:02 INFO: Loading config",
      "2025-09-15 10:30:03 INFO: Database connected",
      "2025-09-15 10:30:04 INFO: Service ready",
      "2025-09-15 10:30:05 INFO: Listening on port 8080"
    ],
    "origin": "先頭（head）。",
    "usage": "ファイルのはじめのほうだけサッと見る（例: head -n 50）。必要な所だけ素早く確認できて時短になる。",
    "missing_impact": "巨大ファイルの先頭確認が毎回重くなり、必要部分へたどり着くのが遅くなる。",
    "background": "テキスト処理の“手早い覗き見”役として定番。"
  },
  {
    "text": "tail",
    "color": "#FF33A1",
    "kunyomi": "終わりを確かめよ。無駄は残すな。",
    "mondai": "末尾を確認したい",
    "example": [
      "$ tail -3 access.log",
      "192.168.1.100 - GET /index.html 200",
      "192.168.1.101 - GET /style.css 200",
      "192.168.1.102 - POST /api/data 201"
    ],
    "origin": "末尾（tail）。",
    "usage": "ファイルのさいごのほうだけ見る。新しい行を追いかけ続けるなら tail -f。変化にすぐ気づけてトラブル対応が早い。",
    "missing_impact": "エラーの出た直後の行を追えず、リアルタイム監視が難しい。障害対応の初動が遅れる。",
    "background": "運用現場で“tail -f”が文化として根づき、ログ監視の基本テクニックになった。"
  },
  {
    "text": "grep",
    "color": "#FFC300",
    "kunyomi": "見逃すな。真実の欠片を拾い集めろ。",
    "mondai": "ログから 'error' を探したい",
    "example": [
      "$ grep 'error' system.log",
      "2025-09-15 10:35:12 ERROR: Connection failed",
      "2025-09-15 10:42:33 ERROR: File not found"
    ],
    "origin": "昔のエディタ（ed）にあった命令 g/re/p が元です。\ng = global（全体に）\nre = regular expression（決まりごとの文字の並び＝パターン）\np = print（見つけたものを表示）\nこの g/re/p を短くして grep と呼ぶようになりました。",
    "usage": "たくさんの文字の中から、ほしい言葉がある行だけをひろい出す。探す時間が短くなって調査がはかどる。",
    "missing_impact": "大量のログやデータから必要箇所を拾えず、手作業での目視確認に時間を奪われる。",
    "background": "edから派生した“正規表現検索”の代表格。開発・運用を問わず、テキスト探索の基盤になった。",
    "trivia": "grep の名前は ed の g/re/p に由来。高速版として ripgrep (rg) などのツールも人気。"
  },
  {
    "text": "find",
    "color": "#DAF7A6",
    "kunyomi": "隠れた道を掘り当てろ。発見が栄光を呼ぶ。",
    "mondai": "条件に合うファイルを探したい",
    "example": [
      "$ find . -name '*.txt'",
      "./documents/readme.txt",
      "./notes/todo.txt",
      "./backup/old.txt"
    ],
    "origin": "find（見つける）。",
    "usage": "条件を決めて、ファイルやフォルダをさがす。見つけたものをそのまま次の処理へ渡せる。欲しいものにすぐ届いて作業が早い。",
    "missing_impact": "必要なファイルを見つけられず、重複作成や誤操作が増える。後続処理の自動化も滞る。",
    "background": "ツリー走査と条件フィルタを組み合わせるUNIX的アプローチの代表格。xargs等と連携して威力を発揮。"
  },
  {
    "text": "chmod",
    "color": "#C70039",
    "kunyomi": "鍵を握る者よ、権限を定めよ。",
    "mondai": "実行権限を付けたい",
    "example": [
      "$ chmod 755 script.sh",
      "$ ls -l script.sh",
      "-rwxr-xr-x 1 user group 1234 script.sh"
    ],
    "origin": "change mode（パーミッション変更）。",
    "usage": "ファイルの読み書き・実行の権限を変える（例: 755 や 644）。必要な人だけに見せたり動かせたりして安全になる。",
    "missing_impact": "過剰/不足な権限で事故や停止が起きる。実行できない・誰でも触れる等のトラブルを招く。",
    "background": "パーミッションのrwxモデルとともに誕生。数値/記号式指定が受け継がれている。",
    "trivia": "まず基本：ファイルの権限は『読む（read）』『書く（write）』『実行（execute）』の3つです。\n次に誰が使えるか：所有者・グループ・その他の3つの区分で、それぞれに権限を設定します。\n表し方：文字（rwx）や数字（例: 755）で表します。数字は 7=rwx、5=r-x、4=r-- のように対応します。\nなぜ権限があるの？ 複数の人で同じコンピュータやサーバを使うとき、他の人のファイルを勝手に読んだり書き換えたり、勝手にプログラムを実行されないように守るためです。\n具体例：公開したくないファイルは「その他」に読み書きを与えず、スクリプトは実行だけできるように実行ビット（x）を付けます。\n注意：『必要な人にだけ、必要な権限を与える（最小権限）』こと。余計な権限は事故や攻撃につながるので注意しましょう。"
  },
  {
    "text": "sudo",
    "color": "#FF5733",
    "kunyomi": "ここで試練を越えよ。許可は与えられた。",
    "mondai": "管理者権限で実行したい",
    "example": [
      "$ sudo apt update",
      "[sudo] password for user:",
      "Get:1 https://archive.ubuntu.com/ubuntu focal InRelease"
    ],
    "origin": "superuser do（管理者として実行）。",
    "usage": "管理者の力を借りてコマンドを実行する。インストールや設定変更に使う。必要な作業を止まらず進められる。",
    "missing_impact": "必要な管理操作ができず、作業が滞る。無理なrootログイン慣行に流れて危険が高まる。",
    "background": "“必要なときだけ権限を借りる”最小権限の実践として普及。監査ログの残しやすさも評価された。",
    "trivia": "Q: root権限を使えば sudo いらなくない？\nA: 技術的には root に直接ログインすれば sudo は不要です。ただし root は何でもできるため、誤操作や攻撃の被害が大きくなります。sudo は『必要な時だけ権限を一時的に借りる』仕組みで、普段は一般ユーザーでいることで安全性を保ちます。\n\nQ: sudo を使うと何でもできるの？\nA: sudo で与えられた権限範囲内の操作は可能ですが、管理者が設定した範囲（sudoers）によって制限できます。すべての sudo ユーザーが無制限に何でもできるわけではなく、設定次第で細かく制御できます。ログ記録や個別の権限付与で安全に運用するのが一般的です。"
  },
  {
    "text": "ps",
    "color": "#3357FF",
    "kunyomi": "戦況を報告しろ。動きを見極めよ。",
    "mondai": "起動中のプロセス一覧を見たい",
    "example": [
      "$ ps aux | head -3",
      "USER  PID %CPU %MEM   VSZ   RSS TTY",
      "root    1  0.0  0.1 225016  8768 ?",
      "user 1234  0.2  2.1 523076 87432 ?"
    ],
    "origin": "process status（プロセス一覧）。",
    "usage": "今うごいているプログラムの一覧を出す。止まっているものや重いものの確認に。原因さがしが早く進む。",
    "missing_impact": "暴走や異常プロセスを把握できず、原因特定や停止の初動が遅れる。",
    "background": "初期UNIXからある調査の基礎。オプション文化（aux/ef等）も定着。"
  },
  {
    "text": "kill",
    "color": "#FF33A1",
    "kunyomi": "立ちはだかるものを排する。躊躇は無用だ。",
    "mondai": "プロセスを停止したい",
    "example": [
      "$ ps aux | grep processname    # プロセス名で探す",
      "user    1234  0.2  2.1 523076 87432 ?  Ssl 10:30 0:00 /usr/bin/processname",
      "$ kill 1234                      # 終了を依頼 (SIGTERM)",
      "# しばらく待ってプロセスが終了するか確認",
      "$ ps aux | grep 1234             # 終了を確認",
      "(no output - process terminated)"
    ],
    "origin": "プロセスにシグナル送信（終了）。",
    "usage": "うごいているプログラムに『終わってね』と合図を送る。どうしても終わらないときは強制終了もできる。固まった時でも復旧しやすい。",
    "missing_impact": "ハングやゾンビを制御できず、資源枯渇やサービス停止を長引かせる。",
    "background": "シグナル機構を介して“丁寧な終了から強制終了まで”段階的に制御する文化を育てた。"
  },
  {
    "text": "df",
    "color": "#FFC300",
    "kunyomi": "残りの余地を示せ。資源は命だ。",
    "mondai": "ディスクの空き容量を確認したい",
    "example": [
      "$ df -h",
      "Filesystem      Size  Used Avail Use% Mounted on",
      "/dev/sda1        20G   15G  4.2G  79% /",
      "tmpfs           2.0G     0  2.0G   0% /tmp"
    ],
    "origin": "disk free（空き容量）。",
    "usage": "ディスクの空き容量がどれくらいかを見る（例: df -h）。満杯トラブルを早めに防げる。",
    "missing_impact": "ディスク満杯を予防できず、書き込み失敗やサービス停止につながる。",
    "background": "マウント単位の可視化で容量管理の標準指標に。人間向け-h表記も普及。"
  },
  {
    "text": "du",
    "color": "#DAF7A6",
    "kunyomi": "足跡の大きさを測れ。無駄は許さん。",
    "mondai": "容量を多く使う場所を調べたい",
    "example": [
      "$ du -sh Documents/",
      "256M    Documents/",
      "$ du -h Documents/ | head -3",
      "12K     Documents/notes"
    ],
    "origin": "disk usage（使用量）。",
    "usage": "どのフォルダがたくさん容量を使っているか調べる。片付ける場所がわかってすぐ整理できる。",
    "missing_impact": "容量の犯人が分からず、片付けや改善の優先度付けができない。",
    "background": "“どこが重いか”を素早く炙り出す現場の定番。後に--max-depth等で使い勝手向上。"
  },
  {
    "text": "ssh",
    "color": "#C70039",
    "kunyomi": "安全な門を通れ。遠方へ手を伸ばせ。",
    "mondai": "リモートにログインしたい",
    "example": [
      "$ ssh user@192.168.1.100",
      "user@192.168.1.100's password:",
      "Welcome to Ubuntu 20.04.3 LTS",
      "user@remote:~$"
    ],
    "origin": "secure shell（暗号化リモート接続）。",
    "usage": "ほかのコンピュータに安全にログインして操作する。離れていても作業できて便利。",
    "missing_impact": "安全な遠隔操作ができず、平文や代替手段に頼って情報漏えいリスクが高まる。",
    "background": "telnet/rshの課題（盗聴）を解決し、公開鍵認証で安全な運用を一般化した。",
    "trivia": "公開鍵は ~/.ssh/authorized_keys。エージェント転送（-A）は便利だがセキュリティ注意。ポートは通常22。"
  },
  {
    "text": "scp",
    "color": "#900C3F",
    "kunyomi": "絆を結べ。データを安全に運べ。",
    "mondai": "ファイルを安全に転送したい",
    "example": [
      "$ scp file.txt user@remote:/home/user/",
      "user@remote's password:",
      "file.txt                    100%  1234     1.2KB/s   00:01"
    ],
    "origin": "secure copy（暗号化コピー）。",
    "usage": "自分のPCとサーバのあいだで、安全にファイルを送ったり受け取ったりする。安心してやり取りできる。",
    "missing_impact": "安全なファイル転送が難しく、手作業での誤送信や漏えいリスクが高まる。",
    "background": "SSHの上で動くコピーとして普及。近年はsftp/rsync等と使い分けられる。"
  },
  {
    "text": "wget",
    "color": "#FF5733",
    "kunyomi": "遠くの宝をこの手に。全ては掴める。",
    "mondai": "URLからファイルをダウンロードしたい",
    "example": [
      "$ wget https://example.com/file.tar.gz",
      "--2025-09-15 10:30:45--  https://example.com/file.tar.gz",
      "Resolving example.com... 93.184.216.34",
      "HTTP request sent, awaiting response... 200 OK",
      "Saving to: 'file.tar.gz'"
    ],
    "origin": "World Wide Web get（Web取得）。",
    "usage": "URLからファイルをダウンロードする。失敗しても自動でやり直せる。自動化しやすく手間が減る。",
    "missing_impact": "自動取得や再試行ができず、手作業ダウンロードで失敗や抜け漏れが増える。",
    "background": "CLIでのHTTP取得を一般化。再帰取得・リトライ等がスクリプト化を支えた。"
  },
  {
    "text": "tar",
    "color": "#33FF57",
    "kunyomi": "記録はまとめられた。過去を抱き止めろ。",
    "mondai": "ファイルを圧縮/展開したい",
    "example": [
      "$ tar -czf archive.tar.gz Documents/",
      "$ tar -tzf archive.tar.gz | head -3",
      "Documents/",
      "Documents/readme.txt",
      "Documents/notes/"
    ],
    "missing_impact": "複数ファイルのまとまりを作れず、配布/バックアップ/展開が煩雑になる。",
    "background": "磁気テープの“梱包”が語源。圧縮コマンド（gzip等）との併用が定番化。",
    "trivia": "tar は tape archive の略。解凍は 'tar -xzf file.tar.gz'（x=展開 z=gzip f=ファイル）。"
  },
  {
    "text": "zip",
    "color": "#3357FF",
    "kunyomi": "荷を小さくして、行動を軽やかに。",
    "mondai": "ZIPで圧縮したい",
    "example": [
      "$ zip -r archive.zip Documents/",
      "  adding: Documents/ (stored 0%)",
      "  adding: Documents/file1.txt (deflated 45%)",
      "  adding: Documents/file2.txt (deflated 32%)"
    ],
    "missing_impact": "異種OS間でのやり取りが滞り、共有や提出が面倒になる。",
    "background": "クロスプラットフォームの事実上標準。GUIとの親和性で一般利用に広まった。"
  },
  {
    "text": "unzip",
    "color": "#FF33A1",
    "kunyomi": "封を解け。真実は中にある。",
    "mondai": "展開して中身を確認したい",
    "example": [
      "$ unzip archive.zip",
      "Archive:  archive.zip",
      " extracting: Documents/file1.txt",
      " extracting: Documents/file2.txt"
    ],
    "origin": "ZIPの展開。",
    "usage": "ZIPファイルを解凍する。受け取ったものをすぐ使える。",
    "missing_impact": "受け取ったアーカイブを扱えず、確認・展開に手間取る。",
    "background": "zip文化の受け取り側として各環境に実装が広がった。"
  },
  {
    "text": "vi",
    "color": "#FF5733",
    "kunyomi": "筆は剣にも似る。書き残せ。",
    "mondai": "viでファイルを編集したい",
    "example": [
      "$ vi config.txt",
      "~",
      "~",
      "\"config.txt\" [New File]",
      "-- INSERT --"
    ],
    "origin": "visual editor（視覚的エディタ）。",
    "usage": "ターミナルで使える古くからのエディタ。最小の環境でも使えることが多い。緊急時でもその場で直せる。",
    "missing_impact": "最小環境での緊急編集ができず、復旧や調査が止まる。",
    "background": "ex/edから発展。vi→vimと進化しつつ“どこでもある編集手段”として定着。",
    "trivia": "終了は :wq、保存せず終了は :q!。ノーマルモードへは Esc。hjkl でカーソル移動。"
  },
  {
    "text": "nano",
    "color": "#57FF33",
    "kunyomi": "小さな刃でも道は切り拓ける。",
    "mondai": "nanoで編集したい",
    "example": [
      "$ nano config.txt",
      "  GNU nano 4.8        config.txt",
      "",
      "",
      "^G Get Help    ^O Write Out   ^W Where Is"
    ],
    "origin": "小さく簡単なエディタ（nano）。",
    "usage": "ターミナルで使えるやさしいエディタ。はじめてでも操作しやすい。迷わず編集できて安心。",
    "missing_impact": "初心者や一次対応で編集が詰まり、作業が遅れる。",
    "background": "易しさ重視の端末エディタとして教育・サーバ現場で普及。"
  },
  {
    "text": "echo",
    "color": "#C70039",
    "kunyomi": "声を送れ。そこに意志が宿る。",
    "mondai": "値や変数を表示したい",
    "example": [
      "$ echo \"Hello World\"",
      "Hello World",
      "$ echo $USER",
      "john"
    ],
    "origin": "反響（出力）を返す。",
    "usage": "文字や変数の中身をそのまま表示する。簡単なメモや確認に。チェックが簡単で素早い。",
    "missing_impact": "簡易な確認やパイプ試作が滞り、検証コストが上がる。",
    "background": "シェルの最小出力原語として標準化。POSIX互換でどこでも使える。"
  },
  {
    "text": "date",
    "color": "#900C3F",
    "kunyomi": "時は刻まれる。今を見逃すな。",
    "mondai": "現在の日時を知りたい",
    "example": [
      "$ date",
      "Fri Jan 10 14:30:45 JST 2025",
      "$ date +%Y-%m-%d",
      "2025-01-10"
    ],
    "origin": "日付/時刻（date）。",
    "usage": "今の日時を表示したり、決まった形で出したりする。記録が分かりやすくなる。",
    "missing_impact": "時刻の記録・整形ができず、ログやファイル名の一貫性が崩れる。",
    "background": "タイムゾーンやフォーマット指定の文化を広め、スクリプトで多用される。"
  },
  {
    "text": "uname",
    "color": "#FF5733",
    "kunyomi": "自らを知れ。それが戦術の始まりだ。",
    "mondai": "OSやカーネル情報を確認したい",
    "example": [
      "$ uname -a",
      "Linux ubuntu 5.15.0-56-generic #62-Ubuntu",
      "SMP Tue Nov 22 19:54:14 UTC 2022",
      "x86_64 x86_64 x86_64 GNU/Linux"
    ],
    "origin": "UNIX name（OS/カーネル情報）。",
    "usage": "使っているOSの種類やバージョンなどを表示する（例: uname -a）。環境に合った対応ができる。",
    "missing_impact": "環境差異に気づけず、誤った手順やバイナリを適用して失敗する。",
    "background": "移植性の高いスクリプトで分岐条件として使われ続ける。"
  },
  {
    "text": "whoami",
    "color": "#33FF57",
    "kunyomi": "名を告げよ。己を示すのだ。",
    "mondai": "現在のユーザー名を知りたい",
    "example": [
      "$ whoami",
      "john",
      "$ id",
      "uid=1000(john) gid=1000(john) groups=1000(john)"
    ],
    "origin": "私は誰？（who am i）。",
    "usage": "今この操作をしているユーザー名を表示する。権限のまちがいに気づける。",
    "missing_impact": "想定外のユーザーで操作し、権限事故や設定汚染を招く。",
    "background": "マルチユーザ前提の確認動作として最初期から存在。"
  },
  {
    "text": "who",
    "color": "#3357FF",
    "kunyomi": "ここにいる者を把握せよ。仲間を知れ。",
    "mondai": "誰がログインしているか見たい",
    "example": [
      "$ who",
      "john     pts/0   2025-01-10 14:00",
      "admin    pts/1   2025-01-10 13:30",
      "$ w",
      "14:30:45 up 2 days, 3:42, 2 users"
    ],
    "origin": "誰がログイン中か（who）。",
    "usage": "いまログインしている人の一覧を表示する。声かけや調整がしやすい。",
    "missing_impact": "同時編集やメンテの衝突に気づけず、事故や作業競合を招く。",
    "background": "共有環境での“今いる人を知る”文化的な習慣を支えた。"
  },
  {
    "text": "top",
    "color": "#FF33A1",
    "kunyomi": "戦況を高みから見よ。視界を制す者が勝つ。",
    "mondai": "システムの負荷を確認したい",
    "example": [
      "$ top",
      "top - 14:30:45 up 2 days,  3:42,  2 users",
      "Tasks: 324 total,   1 running, 323 sleeping",
      "Cpu(s):  2.1%us,  1.2%sy,  0.0%ni, 96.7%id",
      "%Cpu(s):  0.0 us,  0.0 sy,  0.0 ni,100.0 id"
    ],
    "origin": "稼働中プロセスの上位表示。",
    "usage": "コンピュータの元気さ（負荷）や重いアプリをリアルタイムで見る。原因の絞り込みが早い。",
    "missing_impact": "瞬時の負荷状況が掴めず、火消しの優先度判断を誤る。",
    "background": "双方向インタラクティブな監視を一般化し、現場の定番に。"
  },
  {
    "text": "htop",
    "color": "#FFC300",
    "kunyomi": "更なる視点を得よ。全ては管理下に。",
    "mondai": "htopでプロセスを管理したい",
    "example": [
      "$ htop",
      "  1[||||||||||||||||||||||||100.0%]",
      "  2[||||||||||||||||||||||||100.0%]",
      "Mem[||||||||||||||||||||| 8.5G/16.0G]",
      "Swp[                     0K/0K]"
    ],
    "origin": "topの改良版（human-friendly top）。",
    "usage": "topをもっと見やすくしたもの。上下キーでさくさく操作できる。状況把握が楽になる。",
    "missing_impact": "視覚的に状況把握できず、誤操作や判断遅れが起きやすい。",
    "background": "topのUX改善版として誕生。色/キー操作で現場効率を高めた。"
  },
  {
    "text": "history",
    "color": "#DAF7A6",
    "kunyomi": "過去の足跡を読み解け。それが手掛かりだ。",
    "mondai": "コマンド履歴を見たい",
    "example": [
      "$ history | tail -3",
      "  998  ls -la",
      "  999  cd Documents",
      " 1000  history"
    ],
    "origin": "実行履歴。",
    "usage": "これまで打ったコマンドの履歴を見る。まちがい探しややり直しに便利。再実行が簡単で効率が上がる。",
    "missing_impact": "再現性が下がり、同じ操作を何度も手入力してミスが増える。",
    "background": "シェルの利便性向上として履歴と再実行(!)文化が広がった。"
  },
  {
    "text": "alias",
    "color": "#C70039",
    "kunyomi": "名は道具だ。使い分けよ。",
    "mondai": "コマンドの別名を作りたい",
    "example": [
      "$ alias ll='ls -la'",
      "$ ll",
      "total 24",
      "drwxr-xr-x 3 user user 4096 Jan 10 14:30 ."
    ],
    "origin": "別名（alias）。",
    "usage": "よく使うコマンドに短い別名をつける（例: rm を rm -i に）。入力ミスが減って安全。",
    "missing_impact": "毎回長い入力で時間を浪費し、危険な素のコマンドを誤実行しやすい。",
    "background": "ユーザごとの作業流儀を凝縮する習慣として定着。"
  },
  {
    "text": "crontab",
    "color": "#900C3F",
    "kunyomi": "課された巡りを整えよ。律するのだ。",
    "mondai": "定期実行を設定したい",
    "example": [
      "$ crontab -l",
      "0 2 * * * /usr/bin/backup.sh",
      "30 9 * * 1 /usr/bin/weekly-report.sh",
      "# m h dom mon dow command"
    ],
    "origin": "cron table（定期実行の設定表）。",
    "usage": "決まった時間にコマンドを自動で実行するように予約する。手作業が減って忘れない。",
    "missing_impact": "定期処理が手動依存になり、抜け漏れやスケジュール遅延が起きる。",
    "background": "AT/cron文化としてUNIX運用の礎を築き、今も多くの現場で現役。"
  },
  {
    "text": "ping",
    "color": "#FF5733",
    "kunyomi": "返事が来るか、確かめよ。応答は生死を分ける。",
    "mondai": "相手に届くか疎通を確認したい",
    "example": [
      "$ ping -c 3 google.com",
      "PING google.com (172.217.175.78)",
      "64 bytes from nrt20s10-in-f14.1e100.net:",
      "time=15.2 ms"
    ],
    "origin": "ソナー音“ピン”から。到達/遅延確認。",
    "usage": "相手に『届く？』と声をかけて、反応があるかや時間を調べる。ネットの問題かどうか早く見分けられる。",
    "missing_impact": "ネットの生死判定ができず、アプリ/ネットどちらの問題か切り分けが遅れる。",
    "background": "ICMPエコーを使う疎通確認の古典。運用の第一声として定着。"
  },
  {
    "text": "curl",
    "color": "#FFC300",
    "kunyomi": "世界と語れ。情報は刃となる。",
    "mondai": "HTTPヘッダや応答を確認したい",
    "example": [
      "$ curl -I http://google.com",
      "HTTP/1.1 301 Moved Permanently",
      "Location: http://www.google.com/",
      "Content-Type: text/html; charset=UTF-8"
    ],
    "origin": "client URL（URLに対するクライアント）。",
    "usage": "URLにアクセスして、データを取ったり送ったりする。APIのテストに使う。動作確認がサクッとできる。",
    "missing_impact": "HTTP/APIの検証が遅れ、依存サービスの問題発見が後手に回る。",
    "background": "幅広いプロトコル対応とオプション群で“HTTPの瑞ツール”として普及。"
  },
  {
    "text": "ifconfig",
    "color": "#33FF57",
    "kunyomi": "網を整えよ。通信は命綱だ。",
    "mondai": "ネットワークインタフェースの状態を確認したい",
    "example": [
      "$ ifconfig eth0",
      "eth0: flags=4163<UP,BROADCAST,RUNNING,MULTICAST>",
      "        inet 192.168.1.100  netmask 255.255.255.0",
      "        ether 00:11:22:33:44:55  txqueuelen 1000"
    ],
    "origin": "interface config（旧来のNIC設定表示）。",
    "usage": "ネットワークの設定や状態を表示する（古い環境で使うことが多い）。状況把握に役立つ。",
    "missing_impact": "旧環境でのNIC確認ができず、初動の切り分けを逃す。",
    "background": "net-tools系として長らく標準だったが、iproute2へ移行しつつも現場に残る。"
  },
  {
    "text": "ip",
    "color": "#3357FF",
    "kunyomi": "路を知れ。住所は作戦の礎。",
    "mondai": "IPやルーティングを確認/設定したい",
    "example": [
      "$ ip addr show eth0",
      "2: eth0: <BROADCAST,MULTICAST,UP,LOWER_UP>",
      "    inet 192.168.1.100/24 brd 192.168.1.255",
      "    scope global dynamic eth0"
    ],
    "origin": "iproute2のメインコマンド。",
    "usage": "ネットワークの設定や状態をまとめて確認・変更する新しいコマンド。原因切り分けや設定が一気に進む。",
    "missing_impact": "設定/状態の一元把握ができず、断片的な確認でミスが増える。",
    "background": "iproute2として統合的管理を提供し、現代的ネット運用の標準になった。"
  },
  {
    "text": "netstat",
    "color": "#FF33A1",
    "kunyomi": "糸を辿れ。繋がりを掌握するのだ。",
    "mondai": "開いているポートや接続を確認したい",
    "example": [
      "$ netstat -tuln",
      "Proto Recv-Q Send-Q Local Address   Foreign Address",
      "tcp        0      0 0.0.0.0:22      0.0.0.0:*",
      "tcp        0      0 127.0.0.1:3306  0.0.0.0:*"
    ],
    "origin": "network statistics。",
    "usage": "開いているポートや通信の状態を見る（今は ss を使うことも多い）。通信の滞りを見つけやすい。",
    "missing_impact": "通信の詰まりや競合を掴めず、停止や遅延の原因特定が遅れる。",
    "background": "古参の統計ツールとして普及。ssへの世代交代が進むも知識資産は継承。"
  },
  {
    "text": "passwd",
    "color": "#DAF7A6",
    "kunyomi": "鍵を改めよ。守りを固めるのだ。",
    "mondai": "パスワードを変更したい",
    "example": [
      "$ passwd",
      "Changing password for user john.",
      "Current password:",
      "New password:"
    ],
    "origin": "password設定。",
    "usage": "ログインのパスワードを変える。安全を保てる。",
    "missing_impact": "弱い/古いパスワードが放置され、侵入や不正利用のリスクが高まる。",
    "background": "対話的変更によりユーザ主体のセキュリティ運用を支えてきた。"
  },
  {
    "text": "useradd",
    "color": "#C70039",
    "kunyomi": "力を集めよ。仲間を増やすのだ。",
    "mondai": "新しいユーザを追加したい",
    "example": [
      "$ sudo useradd -m newuser",
      "$ id newuser",
      "uid=1001(newuser) gid=1001(newuser)",
      "groups=1001(newuser)"
    ],
    "origin": "ユーザ追加。",
    "usage": "新しいユーザーを作る（ホームフォルダを作るなら -m）。みんなで使う準備が整う。",
    "missing_impact": "アカウント管理が場当たりになり、共有アカウント乱用や監査困難を招く。",
    "background": "ユーザ/グループ管理の標準手順として各ディストリに実装。"
  },
  {
    "text": "userdel",
    "color": "#900C3F",
    "kunyomi": "必要な刃は捨てる。それも任務だ。",
    "mondai": "ユーザを削除したい",
    "example": [
      "$ sudo userdel -r olduser",
      "userdel: user 'olduser' removed",
      "$ id olduser",
      "id: 'olduser': no such user"
    ],
    "origin": "ユーザ削除。",
    "usage": "ユーザーを消す（ホームフォルダごとなら -r）。不要なアカウントを整理できて安全。",
    "missing_impact": "退職者/不要アカウントが残り、情報漏えいや不正アクセスの温床になる。",
    "background": "アカウントのライフサイクルを閉じる最後の一手として必須。"
  },
  {
    "text": "rsync",
    "color": "#FF5733",
    "kunyomi": "心を合わせよ。差異を埋めるのだ。",
    "mondai": "差分同期でコピーしたい",
    "example": [
      "$ rsync -av source/ destination/",
      "sending incremental file list",
      "file1.txt",
      "sent 1,234 bytes  received 89 bytes"
    ],
    "origin": "remote sync（差分同期）。",
    "usage": "ファイルをくらべて、変わったぶんだけすばやくコピーする。転送が速くて失敗に強い。",
    "missing_impact": "全量コピーで時間と帯域を浪費し、差分配布やバックアップが非効率になる。",
    "background": "ローリングチェックサムで差分だけ送る仕組みが革新的だった。"
  },
  {
    "text": "mount",
    "color": "#33FF57",
    "kunyomi": "場を据えよ。準備は戦の布石。",
    "mondai": "デバイスをマウントしたい",
    "example": [
      "$ sudo mount /dev/sdb1 /mnt/usb",
      "$ df -h /mnt/usb",
      "Filesystem      Size  Used Avail Use%",
      "/dev/sdb1       7.5G  1.2G  6.0G  17%"
    ],
    "origin": "ファイルシステムを“据える”。",
    "usage": "USBや外付けディスクなどを『使えるように取り付ける』。保存先が増えて作業が広がる。",
    "missing_impact": "保存先の誤りや未マウントに気づけず、データ消失や処理失敗を招く。",
    "background": "ファイルシステムを“取り付ける”概念の中心。/etc/fstab文化と共に。"
  },
  {
    "text": "umount",
    "color": "#3357FF",
    "kunyomi": "役割を外せ。整理は勝利の鍵。",
    "mondai": "デバイスをアンマウントしたい",
    "example": [
      "$ sudo umount /mnt/usb",
      "$ df -h /mnt/usb",
      "df: '/mnt/usb': No such file or directory"
    ],
    "origin": "un-mount（取り外し）。",
    "usage": "取り付けたディスクを安全にはずす。データの壊れを防げる。",
    "missing_impact": "安全に外せず、キャッシュ未書き込みでデータ破損の危険。",
    "background": "安全な取り外し手順の啓蒙とともに定着。"
  },
  {
    "text": "diff",
    "color": "#FF33A1",
    "kunyomi": "差を見よ。秘密はそこに眠る。",
    "mondai": "ファイルの差分を確認したい",
    "example": [
      "$ diff file1.txt file2.txt",
      "2c2",
      "< old line",
      "---",
      "> new line"
    ],
    "origin": "difference（差分）。",
    "usage": "2つのファイルのちがいをくらべて表示する。変更点が一目でわかる。",
    "missing_impact": "変更点が把握できず、レビューやマージで問題を見逃す。",
    "background": "パッチ文化の礎。ソース管理の前身として広く用いられた。"
  },
  {
    "text": "ln",
    "color": "#FFC300",
    "kunyomi": "絆を結び、道を指せ。",
    "mondai": "シンボリックリンクを作りたい",
    "example": [
      "$ ln -s /path/to/original link_name",
      "$ ls -l link_name",
      "lrwxrwxrwx 1 user user 16 Jan 10 14:30",
      "link_name -> /path/to/original"
    ],
    "origin": "link（リンク作成）。",
    "usage": "元の場所にさわらず、近道（ショートカット）を作る。切り替えが簡単で便利。",
    "missing_impact": "パス切替や共有化が難しく、デプロイや移行の柔軟性が下がる。",
    "background": "ハード/シンボリックの二種リンクがUNIXの柔軟な名前空間を支える。"
  },
  {
    "text": "sort",
    "color": "#DAF7A6",
    "kunyomi": "秩序を作れ。混沌は破るべし。",
    "mondai": "データを並べ替えたい",
    "example": [
      "$ sort unsorted.txt -o sorted.txt",
      "apple",
      "banana",
      "cherry"
    ],
    "origin": "並べ替え。",
    "usage": "文字や数字を順番にならべ替える。データが見やすくなる。",
    "missing_impact": "並び順依存の処理が不安定になり、集計や比較の精度が落ちる。",
    "background": "テキスト指向のデータ処理における基本フィルタとして確立。"
  },
  {
    "text": "wc",
    "color": "#C70039",
    "kunyomi": "数を知れ。情報は力だ。",
    "mondai": "行数や単語数を数えたい",
    "example": [
      "$ wc -l file.txt",
      "42 file.txt",
      "$ echo \"a b c\" | wc -w",
      "3"
    ],
    "origin": "word count（行/単語/文字数カウント）。",
    "usage": "行数・単語数・文字数を数える。ざっくり件数を知りたいときに。進捗や量の把握が簡単。",
    "missing_impact": "規模感を掴めず、計画や進捗見積もりが雑になる。",
    "background": "簡易統計としてスクリプトに組み込まれ続けている。"
  },
  {
    "text": "cut",
    "color": "#900C3F",
    "kunyomi": "必要な部分だけを、断ち切れ。",
    "mondai": "特定の列を抜き出したい",
    "example": [
      "$ cut -d',' -f1 data.csv | head -3",
      "id1",
      "id2",
      "id3"
    ],
    "origin": "文字列を切り出す。",
    "usage": "テキストの一部分（列）だけ切り出す。必要な情報だけ取り出せて整理しやすい。",
    "missing_impact": "不要列に邪魔され、抽出や連携が煩雑になる。",
    "background": "CSV/TSV処理の最小道具として長年用いられる。"
  },
  {
    "text": "sed",
    "color": "#FF5733",
    "kunyomi": "形を変え、真を導け。",
    "mondai": "テキストを一括で置換/抽出したい",
    "example": [
      "$ sed -n '1,3p' file.txt",
      "First line",
      "Second line",
      "Third line"
    ],
    "origin": "stream editor（ストリーム編集）。",
    "usage": "テキストを自動で置きかえたり抜き出したりする。まとめて直すのに便利。大量の修正が一気に終わる。",
    "missing_impact": "機械置換ができず、人手修正でミスと工数が膨らむ。",
    "background": "正規表現と置換を流れの中で行う“ストリーム編集”を一般化。",
    "trivia": "in-place 置換の -i は BSD系で拡張子必須のことがある（例: -i ''）。正規表現拡張は -E で。"
  },
  {
    "text": "awk",
    "color": "#33FF57",
    "kunyomi": "文を操れ。真理を描くのだ。",
    "mondai": "テキストを集計・加工したい",
    "example": [
      "$ awk -F',' '{print $1}' data.csv | head -3",
      "field1",
      "field2",
      "field3"
    ],
    "origin": "作者の頭文字（Aho, Weinberger, Kernighan）。",
    "usage": "テキストの表を計算したり、列ごとに整えたりする。レポート作りに便利。集計が楽になる。",
    "missing_impact": "軽量集計ができず、重い言語や手計算に流れて非効率になる。",
    "background": "1行1レコードの発想で“テキストをデータベースに”する文化を作った。",
    "trivia": "デフォルトの区切りは空白。連想配列とパターン処理が強力で、1行=1レコードの発想で使う。"
  },
  {
    "text": "xargs",
    "color": "#3357FF",
    "kunyomi": "意図を繋げ、力を行使せよ。",
    "mondai": "大量の引数でコマンドを実行したい",
    "example": [
      "$ echo file1 file2 | xargs -n1 echo",
      "file1",
      "file2"
    ],
    "origin": "extended arguments（引数展開）。",
    "usage": "読みこんだ文字を『次に実行するコマンドの引数』として渡す。並列実行する -P もある。大量処理が楽で速い。",
    "missing_impact": "大量の引数渡しや並列実行が手作業になり、時間とミスが増える。",
    "background": "UNIXの“小さな道具をつなぐ”思想のなかで生まれた、引数受け渡しの強化ツール。",
    "trivia": "引数が多いとコマンド行制限を超えるため -n で分割。空白や改行を安全に扱うなら -0 と find -print0。"
  },
  {
    "text": "screen",
    "color": "#FF33A1",
    "kunyomi": "席を保て。長き戦に耐えるために。",
    "mondai": "セッションを保持したい",
    "example": [
      "$ screen -S session1",
      "(new screen session)",
      "$ screen -ls",
      "1234.session1 (Detached)"
    ],
    "origin": "仮想端末を“画面”として多重化。",
    "usage": "回線が切れても作業を続けられる、ターミナルの作業部屋を作る。長時間の作業でも安心。",
    "missing_impact": "リモートが切れたら作業が消える。長時間タスクが不安定になり、やり直しが増える。",
    "background": "リモート作業の定番として長年使われてきた。後継のtmuxと双璧をなす存在。"
  },
  {
    "text": "tmux",
    "color": "#FFC300",
    "kunyomi": "舵を握れ。分割された役割を統べよ。",
    "mondai": "ターミナルを分割して作業したい",
    "example": [
      "$ tmux new -s mysession",
      "$ tmux ls",
      "0: mysession"
    ],
    "origin": "terminal multiplexer（端末多重化）。",
    "usage": "画面を分けたり、作業部屋をいくつも作ったりできる。チームでも共有できる。並行作業がはかどる。",
    "missing_impact": "複数の作業や分割ができず、ウィンドウだらけで混乱する。共有もしづらく非効率。",
    "background": "screenの課題を解決する形で登場。設定の柔軟さや機能の多さで広く普及。",
    "trivia": "デフォルトのプレフィックスは Ctrl-b。デタッチは Ctrl-b, d。設定は ~/.tmux.conf。"
  },
  {
    "text": "bg",
    "color": "#DAF7A6",
    "kunyomi": "影で続けよ。表舞台は別にある。",
    "mondai": "ジョブをバックグラウンドで動かしたい",
    "example": [
      "$ sleep 100 &",
      "[1] 12345",
      "$ bg %1",
      "[1]+ sleep 100 &"
    ],
    "origin": "background（背景に移す）。",
    "usage": "一時停止していた作業を、裏で動かしつづける。待ち時間を有効に使える。",
    "missing_impact": "作業が前面を占有して他の操作が止まる。待ち時間がそのままムダになる。",
    "background": "UNIXシェルのジョブ制御の一部として提供。複数作業を捌く文化を支える。"
  },
  {
    "text": "fg",
    "color": "#C70039",
    "kunyomi": "必要な時に、前へ呼べ。",
    "mondai": "ジョブをフォアグラウンドに戻したい",
    "example": [
      "$ fg %1",
      "sleep 100"
    ],
    "origin": "foreground（前面に戻す）。",
    "usage": "裏で動いている作業を、手前にもどして操作する。すぐ操作に戻れて便利。",
    "missing_impact": "裏で走らせた作業を操作できず、止めたい時や確認したい時に困る。",
    "background": "bgと対になるジョブ制御の要素。シェル文化の基本動作として定着。"
  },
  {
    "text": "jobs",
    "color": "#900C3F",
    "kunyomi": "任務を一覧せよ。動きを止めるな。",
    "mondai": "バックグラウンドジョブを確認したい",
    "example": [
      "$ jobs",
      "[1]+  Running                 sleep 100 &",
      "[2]-  Stopped                 vim"
    ],
    "origin": "シェルのジョブ一覧。",
    "usage": "いまのシェルで動いている作業の一覧を表示する。状況がわかって管理しやすい。",
    "missing_impact": "どの作業が走っているか分からず、重複起動や停止忘れが発生する。",
    "background": "古くからあるジョブ管理の基盤機能。今もCLI中心の現場で必須。"
  },
  {
    "text": "uptime",
    "color": "#FF5733",
    "kunyomi": "時は友だ。耐え続けよ。",
    "mondai": "サーバの稼働時間や負荷を確認したい",
    "example": [
      "$ uptime",
      " 14:30:45 up 2 days,  3:42,  2 users",
      " load average: 0.12, 0.08, 0.05"
    ],
    "origin": "稼働時間/平均負荷。",
    "usage": "PCをどれくらい起動しっぱなしにしているか、最近の重さの目安も表示する。異常に気づきやすい。",
    "missing_impact": "“最近重いのか”が分からず、調査の初動が遅れる。",
    "background": "長期稼働サーバの健全性指標として古くから活用。"
  },
  {
    "text": "free",
    "color": "#33FF57",
    "kunyomi": "備えを示せ。資源は戦力だ。",
    "mondai": "メモリ使用量を確認したい",
    "example": [
      "$ free -h",
      "              total        used        free      shared  buff/cache   available",
      "Mem:           16Gi       4.2Gi       8.5Gi       120Mi       3.3Gi       11Gi"
    ],
    "origin": "メモリの空き/使用量。",
    "usage": "メモリの空き/使用量を表示する。足りなくなりそうか早めに気づける。重くなる前に手を打てる。",
    "missing_impact": "メモリ不足の予兆を見逃し、スワップ多発やサービス低下を招く。",
    "background": "負荷監視の基本指標の一つとして、スクリプトやダッシュボードでも定番。"
  },
  {
    "text": "clear",
    "color": "#3357FF",
    "kunyomi": "画面を払え。心も同じく。",
    "mondai": "画面をクリアしたい",
    "example": [
      "$ clear",
      "(terminal cleared)"
    ],
    "origin": "画面クリア。",
    "usage": "画面をきれいに消して、見やすくする。表示がスッキリして集中しやすい。",
    "missing_impact": "古いログが残って見にくく、必要な情報を見落としやすい。",
    "background": "端末の表示制御の基本機能。多くのシェルで互換の挙動。"
  },
  {
    "text": "whatis",
    "color": "#FF33A1",
    "kunyomi": "意味を問え。深く探るのだ。",
    "mondai": "コマンドの概要を見たい",
    "example": [
      "$ whatis ls",
      "ls (1)             - list directory contents"
    ],
    "origin": "一言説明（what is）。",
    "usage": "コマンドの超短い説明を出す。知らないコマンドでも雰囲気がつかめる。",
    "missing_impact": "初見のコマンドの概要が掴めず、調査に時間がかかる。",
    "background": "manデータベースを活用した要約機能として普及。"
  },
  {
    "text": "which",
    "color": "#FFC300",
    "kunyomi": "真の居場所を示せ。道を見失うな。",
    "mondai": "どの実行ファイルが使われているか知りたい",
    "example": [
      "$ which node",
      "/usr/bin/node"
    ],
    "origin": "どの実行ファイルか（PATH検索）。",
    "usage": "そのコマンドがどの場所のものか（パス）を表示する。まちがった実行を防げる。",
    "missing_impact": "意図しないコマンド（別のバージョンや別の仮想環境）を実行し、トラブルに気づかない。",
    "background": "PATH の確認・整備の定番。開発環境が複雑化するほど重要度が上がった。"
  },
  {
    "text": "locate",
    "color": "#DAF7A6",
    "kunyomi": "道を見つけ出せ。埋もれた真実を掘り起こせ。",
    "mondai": "ファイルを高速で検索したい",
    "example": [
      "$ locate notes.txt | head -3",
      "/home/user/notes.txt",
      "/var/www/html/notes.txt"
    ],
    "origin": "DBを使った高速検索。",
    "usage": "あらかじめ作った名簿（データベース）から、ファイル名をすばやく探す。検索が爆速で時間短縮。",
    "missing_impact": "全ディスク走査に毎回時間がかかり、探すだけで作業が止まる。",
    "background": "updatedbとセットで使う高速検索の定番。大きな環境で威力を発揮。"
  },
  {
    "text": "hostname",
    "color": "#C70039",
    "kunyomi": "名を掲げよ。場所は誇りを示す。",
    "mondai": "ホスト名を確認/設定したい",
    "example": [
      "$ hostname",
      "my-machine"
    ],
    "origin": "ホスト名の表示/設定。",
    "usage": "このPCの名前を表示する／変える。識別しやすくなって管理が楽。",
    "missing_impact": "同じようなホストを見分けられず、誤操作や設定ミスにつながる。",
    "background": "ネットワーク運用での“名付け”文化とともに重要視されてきた。"
  },
  {
    "text": "exit",
    "color": "#900C3F",
    "kunyomi": "退くときは潔く。再起の余地を残せ。",
    "mondai": "セッション終了で区切りを潔くつけたい。",
    "example": [
      "$ exit",
      "logout"
    ],
    "origin": "シェル終了。",
    "usage": "いまのシェル（作業）を終わらせる。区切りがついてトラブルも少ない。",
    "missing_impact": "不要なセッションが残り続け、環境が散らかる。思わぬ実行や占有の原因に。",
    "background": "端末文化の基本動作として最初期から存在。"
  },
  {
    "text": "reboot",
    "color": "#FF5733",
    "kunyomi": "立ち上がれ。再び前へ進むのだ。",
    "mondai": "再起動したい",
    "example": [
      "$ sudo reboot",
      "Broadcast message from root@my-machine"
    ],
    "origin": "再起動。",
    "usage": "コンピュータを再起動する。直らない不調をリセットできる。",
    "missing_impact": "不調時に再起動という選択肢が持てず、復旧に無駄な手間がかかる。",
    "background": "設定反映や障害復旧の最後の切り札として、運用の常識に。"
  },
  {
    "text": "shutdown",
    "color": "#33FF57",
    "kunyomi": "休め。次なる戦へ備えよ。",
    "mondai": "安全にシャットダウンしたい",
    "example": [
      "$ sudo shutdown -h now",
      "System is going down for halting NOW!"
    ],
    "origin": "停止/電源断。",
    "usage": "コンピュータの電源を切る。安全に停止できる。",
    "missing_impact": "安全に止められず、データ破損や整合性エラーのリスクが高まる。",
    "background": "ファイルシステムの整合性維持の観点から、確実な停止手順が重視されてきた。"
  },
  {
    "text": "apt",
    "color": "#3357FF",
    "kunyomi": "管理の刃を振るえ。整えよ。",
    "mondai": "パッケージをインストール/更新したい",
    "example": [
      "$ sudo apt update",
      "Get:1 http://archive.ubuntu.com/ubuntu focal InRelease",
      "Reading package lists... Done"
    ],
    "origin": "Advanced Package Tool（Debian系）。",
    "usage": "ソフトをさがす・入れる・更新する（Debian/Ubuntu系）。必要な道具をすぐ整えられる。",
    "missing_impact": "必要なソフトの導入や更新が遅れ、脆弱性や不一致の原因になる。",
    "background": "パッケージ管理の標準化により、依存関係の自動解決が一般化。運用効率が飛躍した。"
  },
  {
    "text": "yum",
    "color": "#FF33A1",
    "kunyomi": "補完の術を用いよ。選択は知恵だ。",
    "mondai": "パッケージをインストール/更新したい",
    "example": [
      "$ sudo yum install htop",
      "Loaded plugins: fastestmirror",
      "Loading mirror speeds from cached hostfile",
      "Package htop-3.0.5-1.el8.x86_64 already installed"
    ],
    "origin": "Yellowdog Updater, Modified（RHEL系）。",
    "usage": "ソフトをさがす・入れる・更新する（RHEL/CentOS系）。必要な道具をすぐ整えられる。",
    "missing_impact": "ソフトの導入・更新が手詰まりになり、保守やセキュリティ対応が遅れる。",
    "background": "RHEL系の主力ツールとして長らく利用。近年はdnfへ移行が進むが文化は継承。"
  },
  {
    "text": "dnf",
    "color": "#26C6DA",
    "kunyomi": "依存を解き、整えて進め。",
    "mondai": "パッケージをインストール/更新したい",
    "example": [
      "$ sudo dnf install htop",
      "$ sudo dnf update -y"
    ],
    "origin": "Dandified YUM（Fedora/RHEL系）。",
    "usage": "Fedora/RHEL系でソフトを入れる・更新する。yumの後継として扱われることが多い。",
    "missing_impact": "必要なツール導入やセキュリティ更新が滞り、作業が止まったり脆弱性を抱えたままになりやすい。",
    "background": "依存解決や性能改善の流れの中でyumから発展。RHEL 8以降などで標準となり、運用の基本操作として定着。",
    "trivia": "最初に一覧更新が必要な場面では dnf makecache が役立つことがある（環境による）。"
  },
  {
    "text": "pacman",
    "color": "#FFC300",
    "kunyomi": "軽やかに切り拓け。流儀を貫け。",
    "mondai": "パッケージをインストール/更新したい",
    "example": [
      "$ sudo pacman -S htop",
      "resolving dependencies...",
      "looking for conflicting packages...",
      "Packages (1) htop-3.2.1-1"
    ],
    "origin": "package manager（Arch系）。",
    "usage": "ソフトをさがす・入れる・更新する（Arch系）。必要な道具をすぐ整えられる。",
    "missing_impact": "Arch系環境での導入・更新が難しくなり、最新性を活かせない。",
    "background": "ローリングリリース文化を支える高速なパッケージ管理として発展。"
  },
  {
    "text": "ufw",
    "color": "#8E24AA",
    "kunyomi": "門を守れ。通す道を選べ。",
    "mondai": "ファイアウォールを設定したい",
    "example": [
      "$ sudo ufw status",
      "$ sudo ufw allow 22/tcp",
      "$ sudo ufw enable"
    ],
    "origin": "Uncomplicated Firewall（iptables/nftablesの簡易フロント）。",
    "usage": "ポートの許可/拒否や有効化を、分かりやすいコマンドで設定する。サーバ公開前の基本。",
    "missing_impact": "不要なポートが開いたままになり、攻撃面が広がる。逆に必要ポートを閉じて疎通不良を起こすことも。",
    "background": "複雑になりがちなFW設定を簡単にする目的で普及。Ubuntu系などで定番ツールとして使われる。",
    "trivia": "SSH（22番）を許可する前に ufw enable すると、自分を締め出す事故が起きやすいので順序に注意。"
  },
  {
    "text": "systemctl",
    "color": "#DAF7A6",
    "kunyomi": "全てを統べよ。秩序を維持するのだ。",
    "mondai": "サービスを管理したい",
    "example": [
      "$ systemctl status nginx",
      "● nginx.service - A high performance web server",
      "   Loaded: loaded (/lib/systemd/system/nginx.service)",
      "   Active: active (running) since Mon 2025-01-10"
    ],
    "origin": "systemd control（サービス/ユニット管理）。",
    "usage": "サービス（常駐プログラム）を起動・停止したり、自動起動の設定を変える。運用が安定して管理しやすい。",
    "missing_impact": "サービスの起動失敗や自動起動設定の不備に気づけず、停止や復旧が後手に回る。",
    "background": "従来のinitからsystemdへの移行で、サービス管理の標準手順として確立。"
  },
  {
    "text": "journalctl",
    "color": "#C70039",
    "kunyomi": "歴史を読み、真実を守れ。",
    "mondai": "ジャーナルログで原因を調べたい",
    "example": [
      "$ journalctl -u nginx.service",
      "Jan 10 14:30:45 server nginx[1234]: starting server",
      "Jan 10 14:30:46 server nginx[1234]: server started",
      "Jan 10 14:30:47 server nginx[1234]: ready to accept"
    ],
    "origin": "systemdのジャーナル閲覧。",
    "usage": "サービスの動作ログを見る。起動時のエラーも追える（例: -u, -b, -f）。原因調査がスムーズ。",
    "missing_impact": "原因が分からず復旧が遅れる。必要なログを横断して追えない。",
    "background": "バイナリジャーナルの登場で、時系列/フィルタが強化され、運用の当たり前に。"
  },
  {
    "text": "syslog",
    "color": "#900C3F",
    "kunyomi": "叫びを記せ。証を残すのだ。",
    "mondai": "syslogを監視したい",
    "example": [
      "$ tail -f /var/log/syslog",
      "Jan 10 14:30:45 server kernel: [12345.678] USB disconnect",
      "Jan 10 14:30:46 server systemd: Starting Clean up",
      "Jan 10 14:30:47 server cron: (root) CMD (run-parts)"
    ],
    "origin": "system log（従来のログ機構）。",
    "usage": "昔からあるログの仕組み。/var/log の記録をチェックする。トラブルの手がかりが見つかる。",
    "missing_impact": "昔ながらのログを見られず、軽い不具合の早期発見が難しくなる。",
    "background": "UNIX黎明期からの標準。多くのツールや文化がこの仕組みに依存してきた。"
  },
  {
    "text": "man",
    "color": "#1E90FF",
    "kunyomi": "書は道標。まずは読め。",
    "mondai": "コマンドの使い方を知りたい",
    "example": [
      "$ man ls",
      "LS(1) User Commands LS(1)",
      "-l  use a long listing format"
    ],
    "origin": "manual（公式マニュアル）。",
    "usage": "公式の説明書を読む。正しい使い方や例がのっている。迷わず正確に使える。",
    "missing_impact": "Web検索頼みで情報がバラバラになり、誤情報に振り回される。",
    "background": "UNIX文化の“ドキュメントはmanにある”を体現。今も信頼の第一ソース。"
  },
  {
    "text": "apropos",
    "color": "#20B2AA",
    "kunyomi": "言葉から道を探せ。",
    "mondai": "キーワードでコマンドを探したい",
    "example": [
      "$ apropos \"list directory\"",
      "ls (1)             - list directory contents"
    ],
    "origin": "“適切な”の意。説明に合うコマンドを検索。",
    "usage": "やりたいことの言葉から、関係ありそうなコマンドを探す。知らなくても道筋が見える。",
    "missing_impact": "適切なコマンドに出会えず、遠回りの作業や非効率が続く。",
    "background": "manデータベースを横断的に引ける“入口”として生まれた。"
  },
  {
    "text": "chown",
    "color": "#FF8C00",
    "kunyomi": "持ち主を正せ。責任の所在を明らかに。",
    "mondai": "ファイルの所有者/グループを変更したい",
    "example": [
      "$ sudo chown user:group file.txt",
      "$ ls -l file.txt"
    ],
    "origin": "change owner（所有者変更）。",
    "usage": "ファイルの持ち主やグループを変える。正しい人だけが触れられて安全。",
    "missing_impact": "責任の所在が曖昧になり、アクセス権の事故やトラブルの温床になる。",
    "background": "マルチユーザ文化の安全運用を支える基本機能。"
  },
  {
    "text": "chgrp",
    "color": "#8A2BE2",
    "kunyomi": "仲間を入れ替え、通るべき道を開け。",
    "mondai": "ファイルのグループを変更したい",
    "example": [
      "$ sudo chgrp developers file.txt",
      "$ ls -l file.txt"
    ],
    "origin": "change group（グループ変更）。",
    "usage": "ファイルのグループを変える。みんなで編集できるようにする、など。共同作業がスムーズ。",
    "missing_impact": "編集や閲覧の範囲が適切に設定できず、共同作業の停滞や情報漏れにつながる。",
    "background": "UNIXの“ユーザ/グループ/その他”権限モデルの根幹。"
  },
  {
    "text": "usermod",
    "color": "#FF69B4",
    "kunyomi": "器を整えよ。役割は変えられる。",
    "mondai": "ユーザーをグループに追加したい",
    "example": [
      "$ sudo usermod -aG sudo user",
      "$ groups user"
    ],
    "origin": "ユーザ属性の変更。",
    "usage": "ユーザーの設定を変える（グループ追加、ログインシェル変更など）。運用が整って管理が楽。",
    "missing_impact": "組織変更や役割変更に追随できず、不要な権限や設定が残る。",
    "background": "アカウントライフサイクル管理の実務を支えるコマンド。"
  },
  {
    "text": "stat",
    "color": "#2E8B57",
    "kunyomi": "細部に真がある。",
    "mondai": "ファイルの詳細情報を確認したい",
    "example": [
      "$ stat file.txt",
      "Size: 1234   Blocks: 8   IO Block: 4096",
      "Access: (0644/-rw-r--r--)  Uid: ( 1000/ user)"
    ],
    "origin": "status由来。詳細メタ情報表示。",
    "usage": "ファイルのくわしい情報（権限・サイズ・更新時刻など）を見る。問題の見落としが減る。",
    "missing_impact": "パーミッションやタイムスタンプの問題を見落とし、原因の特定に時間がかかる。",
    "background": "トラブルシューティングの初動確認として定番。"
  },
  {
    "text": "file",
    "color": "#708090",
    "kunyomi": "正体を見極めよ。",
    "mondai": "ファイル種別を判定したい",
    "example": [
      "$ file image.bin",
      "image.bin: ELF 64-bit LSB executable"
    ],
    "origin": "ファイルの種別推定（マジックナンバー判定）。",
    "usage": "そのファイルがテキストか画像か、圧縮かなどを判定する。開き方をまちがえにくい。",
    "missing_impact": "正体不明のファイルで手が止まり、誤ったツールで開いて壊すリスクがある。",
    "background": "拡張子に頼らず中身で判断する文化を広めた実用ツール。"
  },
  {
    "text": "lsblk",
    "color": "#B22222",
    "kunyomi": "器の全景を掴め。",
    "mondai": "ブロックデバイスとマウントを確認したい",
    "example": [
      "$ lsblk",
      "NAME   MAJ:MIN RM SIZE RO TYPE MOUNTPOINTS",
      "sda      8:0    0 100G  0 disk",
      "├─sda1   8:1    0  96G  0 part /"
    ],
    "origin": "list block devices。",
    "usage": "つないでいるディスクと、その取り付け先を一覧で見る。間違った扱いを防げる。",
    "missing_impact": "どのディスクがどこに付いているか分からず、誤消去や誤マウントの事故につながる。",
    "background": "ストレージ構成の可視化により、運用の安全性を大きく高めた。"
  },
  {
    "text": "fdisk",
    "color": "#CD5C5C",
    "kunyomi": "区切りを知れ。器の内側を描け。",
    "mondai": "パーティション一覧を確認したい",
    "example": [
      "$ sudo fdisk -l",
      "Disk /dev/sda: 100 GiB",
      "Device     Start       End   Sectors"
    ],
    "origin": "format diskではなく“fdisk”。古参のパーティション編集。",
    "usage": "ディスクの中を区切る（パーティション）ための古いツール。今は parted も使う。正しく分けられて管理しやすい。",
    "missing_impact": "ディスクの区切りを誤って、データ消失や起動不能を招きやすい。",
    "background": "伝統的ツールとして今も現場に残る。新世代ツールと役割分担しながら利用される。"
  },
  {
    "text": "gzip",
    "color": "#228B22",
    "kunyomi": "軽さは力。荷を縮めよ。",
    "mondai": "ファイルを圧縮/展開したい",
    "example": [
      "$ gzip file.txt",
      "$ gunzip file.txt.gz"
    ],
    "origin": "GNU zip（圧縮形式）。",
    "usage": "ファイルを .gz という形式で圧縮・展開する。容量が小さくなって転送が楽。",
    "missing_impact": "大きなファイルの配布や保管が非効率になり、帯域や容量を圧迫する。",
    "background": "シンプルで高速。ログの圧縮など日常運用で広く使われる。"
  },
  {
    "text": "sha256sum",
    "color": "#8B4513",
    "kunyomi": "証を刻め。改竄を許すな。",
    "mondai": "ダウンロードの整合性を確認したい",
    "example": [
      "$ sha256sum file.iso",
      "d2c7...  file.iso"
    ],
    "origin": "SHA-256のハッシュ値を計算。",
    "usage": "ファイルが正しいかを数字（ハッシュ）で確認する。改ざんを見抜けて安心。",
    "missing_impact": "配布物の破損や改ざんに気づけず、セキュリティ事故のきっかけになる。",
    "background": "チェックサム文化の進化版として、より強いSHA-256が一般化。"
  },
  {
    "text": "tr",
    "color": "#6A5ACD",
    "kunyomi": "置き換えは術。形を整えよ。",
    "mondai": "文字置換をしたい",
    "example": [
      "$ echo hello | tr 'a-z' 'A-Z'",
      "HELLO"
    ],
    "origin": "translate/transliterate。",
    "usage": "文字を別の文字に置きかえる。大文字↔小文字の変換など。整形が簡単で読みやすくなる。",
    "missing_impact": "機械的な置換が手作業になり、ミスやムダが増える。",
    "background": "フィルタとしてパイプに挟んで使う思想を体現する小さな道具。"
  },
  {
    "text": "uniq",
    "color": "#FF7F50",
    "kunyomi": "重なりを圧せ。要点だけを残せ。",
    "mondai": "重複行をまとめたい。",
    "example": [
      "$ sort items.txt | uniq -c | sort -nr | head",
      " 42 apple",
      " 17 banana"
    ],
    "origin": "unique（重複の圧縮）。",
    "usage": "同じ行が続いていたら1つにまとめる（ふつうは sort と一緒に使う）。重複をへらして見やすい。",
    "missing_impact": "重複が多い結果をそのまま扱い、重要な傾向を見落とす。",
    "background": "ログや一覧の後処理における定番フィルタ。"
  },
  {
    "text": "tee",
    "color": "#008B8B",
    "kunyomi": "流れを分け、記録を残せ。",
    "mondai": "画面に表示しつつファイルにも保存したい。",
    "example": [
      "$ command | tee output.log",
      "$ tail output.log"
    ],
    "origin": "配管のT字分岐から。",
    "usage": "画面に表示しつつ、同じ内容をファイルにも保存する。証拠を残せて安心。",
    "missing_impact": "その場で見た結果が残らず、後から確認できない。トレーサビリティが失われる。",
    "background": "“見せつつ残す”ワークフローを簡単にする実用ツール。"
  },
  {
    "text": "pgrep",
    "color": "#2F4F4F",
    "kunyomi": "名から敵を見つけ出せ。",
    "mondai": "プロセス名でPIDを探したい。",
    "example": [
      "$ pgrep nginx",
      "1234"
    ],
    "origin": "process grep。",
    "usage": "名前でプロセス（動いているプログラム）を探して、番号（PID）を知る。狙い撃ちで操作できる。",
    "missing_impact": "対象プロセスが特定できず、誤った停止や監視漏れを招く。",
    "background": "grep文化をプロセス世界に持ち込んだ便利ツール。"
  },
  {
    "text": "lsof",
    "color": "#DC143C",
    "kunyomi": "開かれた手掛かりを洗え。",
    "mondai": "どのプロセスがそのポートやファイルを使っているか知りたい。",
    "example": [
      "$ sudo lsof -i :80 | head -3",
      "nginx  1234 root  IPv4 ... TCP *:http (LISTEN)"
    ],
    "origin": "list open files。",
    "usage": "どのプロセスが、どのファイルやポートを使っているか調べる。奪い合いの原因がわかる。",
    "missing_impact": "“誰が掴んでいるか”が分からず、解放待ちや衝突の解消に時間がかかる。",
    "background": "運用トラブルの原因追及で頻出。必携の調査ツールとして定着。"
  },
  {
    "text": "strace",
    "color": "#FF4500",
    "kunyomi": "呼び声を追え。闇の中の動きを暴け。",
    "mondai": "原因不明のハングや失敗をシステムコールで追いたい。",
    "example": [
      "$ strace -o trace.log -f ./app",
      "openat(AT_FDCWD, \"/etc/ld.so.cache\", O_RDONLY|O_CLOEXEC) = 3"
    ],
    "origin": "system call trace。",
    "usage": "プログラムがOSに何をお願いしているかを追いかけて、つまずき場所を見つける。原因がハッキリして直しやすい。",
    "missing_impact": "“どこで詰まるか”がブラックボックスになり、バグの特定が長引く。",
    "background": "Linuxでの低レベル解析の定番。開発/運用の垣根を越えて使われる。"
  },
  {
    "text": "watch",
    "color": "#7B68EE",
    "kunyomi": "見張れ。変化は兆しだ。",
    "mondai": "コマンド結果を定期的に更新表示したい。",
    "example": [
      "$ watch -n 1 'df -h | head -3'"
    ],
    "origin": "監視（定期的に実行して表示）。",
    "usage": "同じコマンドを一定間隔でくり返し実行して、変化を見守る。状態の変化を見逃しにくい。",
    "missing_impact": "手動で連打・比較することになり、変化点の見落としや反応遅れを招く。",
    "background": "一次監視や軽量な観察に最適な古参ツール。"
  },
  {
    "text": "ss",
    "color": "#696969",
    "kunyomi": "糸を視る。繋がりの現在地。",
    "mondai": "LISTENポートを確認したい",
    "example": [
      "$ ss -tuln | head -5",
      "Netid State  Local Address:Port  Peer Address:Port"
    ],
    "origin": "socket statistics。",
    "usage": "いま開いているポートや通信のつながりを、速く表示する。高速で確認できて効率的。",
    "missing_impact": "通信トラブル時に現状把握が遅れ、復旧が後手に回る。",
    "background": "netstatの後継として高速/簡潔な出力が重宝され、近年の主流に。"
  },
  {
    "text": "tcpdump",
    "color": "#556B2F",
    "kunyomi": "流れを掬え。見えぬ情報を掴む。",
    "mondai": "ポート通信をキャプチャしたい",
    "example": [
      "$ sudo tcpdump -i eth0 port 443 -c 5",
      "5 packets captured"
    ],
    "origin": "TCPを“ダンプ”する解析ツール。",
    "usage": "やり取りされる通信の中身をキャプチャして、原因調査に使う。どこで詰まっているか見える。",
    "missing_impact": "パケットの中身が見えず、暗中模索の切り分けになって時間がかかる。",
    "background": "ネットワーク解析の基礎。WiresharkなどGUI系とも相互補完。"
  },
  {
    "text": "dig",
    "color": "#8B0000",
    "kunyomi": "名を辿り、居場所を掘り当てろ。",
    "mondai": "DNSレコードを調べたい",
    "example": [
      "$ dig +short google.com",
      "142.250.196.206"
    ],
    "origin": "domain information groper。",
    "usage": "DNS（名前からIPを調べるしくみ）のくわしい結果を見る。設定ミスや原因を見つけやすい。",
    "missing_impact": "ネーム解決の不調を切り分けられず、接続トラブルが長引く。",
    "background": "DNS運用/調査の王道ツールとして長年使われている。"
  },
  {
    "text": "traceroute",
    "color": "#008000",
    "kunyomi": "道筋を追え。どこで詰まる？",
    "mondai": "経路の遅延箇所を調べたい",
    "example": [
      "$ traceroute example.com | head -3",
      " 1  192.168.1.1  1.123 ms",
      " 2  * * *"
    ],
    "origin": "経路（route）を追跡。",
    "usage": "ネットの道すじを1つずつたどって、どこで遅いかを調べる。ボトルネックを見つけやすい。",
    "missing_impact": "遅い場所が分からず、ネットワークのどこを直せばいいか判断できない。",
    "background": "経路可視化の基本。クラウド/ISPまたぎの切り分けにも定番。"
  },
  {
    "text": "nc",
    "color": "#FF1493",
    "kunyomi": "門を叩け。疎通は最初の一歩。",
    "mondai": "TCPポートの疎通を確認したい。",
    "example": [
      "$ nc -vz 127.0.0.1 22",
      "Connection to 127.0.0.1 22 port [tcp/ssh] succeeded!"
    ],
    "origin": "netcat（ネットの猫）。",
    "usage": "ポートの通信テストや、かんたんなサーバ・転送に使える多用途ツール。困ったときの切り分けが早い。",
    "missing_impact": "疎通の有無がすぐ検証できず、原因箇所の切り分けが遅れる。",
    "background": "“ネットワークの瑞 Swiss Army Knife”と呼ばれるほど多機能。"
  },
  {
    "text": "dmesg",
    "color": "#191970",
    "kunyomi": "核の声を聴け。",
    "mondai": "カーネルメッセージを確認したい",
    "example": [
      "$ dmesg | tail -5",
      "usb 1-1: new high-speed USB device number 4"
    ],
    "origin": "diagnostic message（カーネルメッセージ）。",
    "usage": "機器をつないだときなどの、OSの最新メッセージを見る。異常にすぐ気づける。",
    "missing_impact": "OSの声が聞けず、ドライバやハードの異常に気づきにくい。",
    "background": "低レイヤの手がかりとして昔から使われる。systemd 環境でも根強く活躍。"
  },
  {
    "text": "sysctl",
    "color": "#A0522D",
    "kunyomi": "律を定め、器を調律せよ。",
    "mondai": "カーネルパラメータを確認/設定したい",
    "example": [
      "$ sysctl net.ipv4.ip_forward",
      "net.ipv4.ip_forward = 0",
      "$ sudo sysctl -w net.ipv4.ip_forward=1"
    ],
    "origin": "system control。",
    "usage": "OSの細かな設定を、その場で見たり一時的に変えたりする。試しながら最適化できる。",
    "missing_impact": "チューニングや一時対処ができず、再起動やビルドに頼る非効率な運用になる。",
    "background": "Linuxカーネルの動的制御インターフェイスとして定着。"
  },
  {
    "text": "tree",
    "color": "#32CD32",
    "kunyomi": "森を俯瞰し、道を見つけよ。",
    "mondai": "ディレクトリ構造をツリー表示したい",
    "example": [
      "$ tree -L 2",
      ".\n├── src\n│   ├── App.js\n│   └── index.js\n└── package.json"
    ],
    "origin": "木構造表示。",
    "usage": "フォルダの中を木の形で表示して、全体のつくりをながめる。構造が一目でわかる。",
    "missing_impact": "全体像が掴めず、深い階層の把握やレビューが難しい。",
    "background": "ディレクトリの可視化ツールとして、設計やレビューで重宝される。"
  },
  {
    "text": "blkid",
    "color": "#00CED1",
    "kunyomi": "印を読め。識別子は真実を語る。",
    "mondai": "デバイスのUUIDやファイルシステム種別を知りたい。",
    "example": [
      "$ sudo blkid",
      "/dev/sda1: UUID=\"...\" TYPE=\"ext4\""
    ],
    "origin": "block id（識別子）。",
    "usage": "ディスクのIDや種類を表示して、設定に使える情報を知る。間違い設定を防げる。",
    "missing_impact": "fstab等で識別子を使えず、差し替えや再接続時にマウントがズレる。",
    "background": "UUIDベースの安定した設定を支える裏方。"
  },
  {
    "text": "parted",
    "color": "#8FBC8F",
    "kunyomi": "大きな器も切り分けよ。",
    "mondai": "GPTや大容量ディスクのパーティションを扱いたい。",
    "example": [
      "$ sudo parted -l",
      "Model: ATA VBOX HARDDISK",
      "Partition Table: gpt"
    ],
    "origin": "partition editor。",
    "usage": "新しい規格に対応したパーティション操作ツール。作成や表示ができる。大容量でも正しく扱える。",
    "missing_impact": "新しいディスク規格や大容量領域に対応できず、運用のボトルネックになる。",
    "background": "fdiskの限界を補う現代的ツールとして普及。"
  },
  {
    "text": "base64",
    "color": "#BA55D3",
    "kunyomi": "形を変えて渡せ。",
    "mondai": "簡易エンコードやデコードをしたい。",
    "example": [
      "$ echo -n 'secret' | base64",
      "c2VjcmV0",
      "$ echo c2VjcmV0 | base64 -d"
    ],
    "origin": "64種の文字で表すエンコード。",
    "usage": "データを文字だけに変えて、送ったり設定に入れたりする。もとに戻すこともできる。環境に左右されず扱いやすい。",
    "missing_impact": "バイナリを安全に運べず、コピー&ペーストや設定への埋め込みが難しい。",
    "background": "メールや設定ファイルでのデータ持ち運びを可能にした定番手法。"
  },
  {
    "text": "iconv",
    "color": "#DAA520",
    "kunyomi": "言葉の器を換えよ。",
    "mondai": "文字コードをUTF-8へ変換したい。",
    "example": [
      "$ iconv -f SHIFT_JIS -t UTF-8 in.txt > out.txt"
    ],
    "origin": "internationalization conversion。",
    "usage": "文字コード（UTF-8 や SJIS など）を別の種類に変える。文字化けを防げて安心。",
    "missing_impact": "文字コード不一致で “文字化け地獄” に陥り、共有や処理でトラブルが増える。",
    "background": "国際化対応の現場で必須の変換ツールとして長年使われる。"
  },
  {
    "text": "pstree",
    "color": "#4169E1",
    "kunyomi": "系譜を視よ。親子の流れを掴め。",
    "mondai": "プロセスの親子関係を一望したい。",
    "example": [
      "$ pstree -p | head -3",
      "systemd(1)─┬─sshd(721)─┬─sshd(1023)"
    ],
    "origin": "process tree（親子関係の木）。",
    "usage": "動いているプログラムの親子関係を、木の形で表示する。どれが原因か追いやすい。",
    "missing_impact": "親子関係が見えず、ゾンビ/孤児プロセスなどの異常に気づきにくい。",
    "background": "プロセス管理の全体像を掴むための定番ユーティリティ。"
  },
  {
    "text": "nohup",
    "color": "#8B008B",
    "kunyomi": "離れても続け。任務は止めるな。",
    "mondai": "ログアウトしてもプロセスを継続させたい。",
    "example": [
      "$ nohup long_task.sh > out.log 2>&1 &",
      "[1] 23456"
    ],
    "origin": "no hangup（切断でも落ちない）。",
    "usage": "ログアウトしても止まらないように、長時間の作業を動かし続ける。夜間も安心して任せられる。",
    "missing_impact": "リモート切断で処理が止まり、やり直しや再実行の手間が増える。",
    "background": "サーバ常駐タスクの簡易的な継続手段として長く愛用される。"
  },
  {
    "text": "timedatectl",
    "color": "#00BFFF",
    "kunyomi": "時を正せ。世界を合わせよ。",
    "mondai": "時刻/タイムゾーンを確認・設定したい。",
    "example": [
      "$ timedatectl",
      "Time zone: Asia/Tokyo (JST, +0900)"
    ],
    "origin": "time/date control（systemdの時刻管理）。",
    "usage": "時間帯（タイムゾーン）や時計の自動合わせ（NTP）を確認・設定する。時刻ズレのトラブルを防げる。",
    "missing_impact": "時刻ズレで証明書/ログ/ジョブが破綻し、障害や監査不整合を招く。",
    "background": "systemdに統合された時刻管理。NTPと併用して“正しい時刻”を前提化。"
  },
  {
    "text": "mktemp",
    "color": "#CD853F",
    "kunyomi": "一時の器を用意せよ。",
    "mondai": "衝突しない一時ファイル/ディレクトリを作りたい。",
    "example": [
      "$ mktemp -d",
      "/tmp/tmp.ABC123"
    ],
    "origin": "make temporary（安全な一時ファイル/ディレクトリ）。",
    "usage": "他とかぶらない安全な一時フォルダ/ファイルを作る。衝突による失敗を避けられる。",
    "missing_impact": "一時ファイルの衝突や露出で、上書き事故や情報漏えいのリスクが高まる。",
    "background": "安全なテンポラリ生成の手順を標準化し、レース条件を避ける実装が広まった。"
  }
];
